import {Navigate} from "react-router-dom";
import {useFunnel} from "@tinct/web-funnel";
import {useCurrentWorkspaceUrlPrefix} from "@tinct/core-workspace";
import {CampaignCreationFunnelState} from "./campaign-creation-funnel";
import {CampaignSetupStep, getCampaignSetupStep} from "./get-campaign-setup-step";

const STEP_ROUTE: Record<Exclude<CampaignSetupStep, 'live'>, string> = {
  configure: 'configure',
  analyze: 'analyze',
  building: 'building',
  edit: 'edit',
  audience: 'audience',
  sampling: 'sampling',
  preview: 'preview',
  publish: 'publish',
  publishing: 'publishing',
};

export function CampaignCreationFunnelDispatcher() {
  const { steps, state, baseUrl } = useFunnel<CampaignCreationFunnelState>();
  const currentWorkspaceUrlPrefix = useCurrentWorkspaceUrlPrefix();
  const campaign = state.campaign;

  if (steps.length === 0) {
    return <Navigate to={baseUrl} replace />;
  }

  const step = getCampaignSetupStep(campaign);

  // The funnel has no "live" step anymore: a published (or fully set up)
  // campaign is handled on its dashboard.
  if (step === 'live') {
    return (
      <Navigate
        to={`${currentWorkspaceUrlPrefix}/campaigns/${campaign.id}`}
        replace
      />
    );
  }

  return <Navigate to={`${baseUrl}/${STEP_ROUTE[step]}`} replace />;
}
